import FormContainer from "./components/container"
import FormRow from "./components/row"
import FormGroup from "./components/group"
import FormRender from "./components/render"
import handleErrors from "./scripts/handleErrors"

const Form = {
    Container: FormContainer,
    Row: FormRow,
    Group: FormGroup,
    Render: FormRender,
}

export default Form
export {
    FormContainer, FormRow, FormGroup, FormRender,
    handleErrors,
}